import RichText from "@/components/RichText";

// Renders an editor entry the way its public detail page will look. Reads the
// live `data` object so it updates as the admin types.
export default function EntryPreview({ schema, data }) {
  const d = data || {};
  const img = d.image || d.image_url || d.cover;
  const title = d.title || d.name || d.en || d.question || "";
  const deva = d.deva_name || d.deva || "";
  const subtitle = d.subtitle || d.epithet || d.tagline || d.domain || "";
  const heading = d.detail_heading || "";
  const richFields = (schema || []).filter((f) => f.t === "rich" && d[f.k]);
  const points = Array.isArray(d.points) ? d.points.filter((p) => p && (p.title || p.text || p.en || p.hi)) : [];
  const strLists = (schema || []).filter((f) => f.t === "strlist" && Array.isArray(d[f.k]) && d[f.k].filter(Boolean).length);

  return (
    <div data-testid="entry-preview" className="reading-content max-w-none">
      {img && <img src={img} alt="" className="mb-5 h-52 w-full rounded-sm object-cover" />}
      {deva && <p className="font-deva text-3xl text-ink deva-lh">{deva}</p>}
      {title
        ? <h1 className="mt-1 font-serif-latin text-4xl leading-tight text-ink">{title}</h1>
        : <p className="text-ink-3">Start typing to see the preview…</p>}
      {subtitle && <p className="mt-2 text-lg text-gold">{subtitle}</p>}
      {heading && <h2 className="mt-8 font-serif-latin text-2xl text-ink">{heading}</h2>}

      {richFields.map((f) => (
        <div key={f.k} className="mt-5">
          {!["summary", "summary_hi", "body", "body_hi", "description"].includes(f.k) && (
            <p className="overline-label mb-1 text-ink-3">{f.label}</p>
          )}
          <RichText value={d[f.k]} className="text-[17px] leading-[1.9] text-ink-2" />
        </div>
      ))}

      {points.length > 0 && (
        <ul className="mt-6 space-y-2">
          {points.map((p, i) => (
            <li key={i} className="border-l-2 border-[var(--gold)]/50 pl-4">
              <span className="font-medium text-ink">{p.title || p.en || ""}</span>
              {(p.text || p.body || p.hi) && <span className="ml-1 text-ink-2">— {p.text || p.body || p.hi}</span>}
            </li>
          ))}
        </ul>
      )}

      {strLists.map((f) => (
        <div key={f.k} className="mt-5">
          <p className="overline-label text-ink-3">{f.label}</p>
          <ul className="mt-1 list-disc space-y-1 pl-5 text-ink-2">
            {d[f.k].filter(Boolean).map((s, i) => <li key={i}>{s}</li>)}
          </ul>
        </div>
      ))}
    </div>
  );
}
